export function isObject(thing) {
  return thing != null;
}
//# sourceMappingURL=isObject.js.map